import { render, staticRenderFns } from "./FirstChild.vue?vue&type=template&id=6d0d0d21&scoped=true"
import script from "./FirstChild.vue?vue&type=script&lang=js"
export * from "./FirstChild.vue?vue&type=script&lang=js"
import style0 from "./FirstChild.vue?vue&type=style&index=0&id=6d0d0d21&prod&lang=scss&scoped=true"
import style1 from "./FirstChild.vue?vue&type=style&index=1&id=6d0d0d21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d0d21",
  null
  
)

export default component.exports